import React from 'react';
import {connect} from 'react-redux';
import SideNav from 'components/layout/SideNav';
import MobileNav from 'components/layout/MobileNav'
import HeaderNav from 'components/layout/HeaderNav';
import Footer from 'components/layout/Footer';
import AppRouter from 'components/app/router/AppRouter';
import {Button, Layout, Spin,} from "antd";
import {SIDE_NAV_COLLAPSED_WIDTH, SIDE_NAV_WIDTH,} from 'model/constants/ThemeConstant';
import actions from "redux/actions";
import IModule from "../../model/interface/dataStorage/IModule";
import IBaseProps from "../../model/interface/IBaseProps";
import {ReloadOutlined} from "@ant-design/icons";
import IScreen from "../../model/interface/ui/IScreen";
import ISettings from "../../model/interface/ui/ISettings";
import Utils from "../../utils";
import {load} from "../../redux/actions/Setup";
import PushNotificationsService from "../../model/service/push-notifications/PushNotificationsService";
import {IAppState} from "../../redux/store";


const {Content} = Layout;

interface IProps extends IBaseProps {
    navCollapsed: boolean,
    margin: string,
    fontSize: string,
    tableSize: string,
    navType: string,
    locale: string,
    loaded: boolean,
    loading: boolean,
    modules: IModule[],
    load: () => { type: string; },
    loadNotifications: () => void
    reloadNotifications: () => void
    onIsMobileChange: (toggle: boolean) => void,
    settings: ISettings
    headerHeight?: number
}

interface IState {
    interval: NodeJS.Timeout | null
    reloadAvailable: boolean
    screen: IScreen
    screenTimeout: null | NodeJS.Timeout
    reloadButtonTimeout: null | NodeJS.Timeout
    initialized: boolean
}

class AppLayout extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props)
        this.state = {
            interval: null,
            reloadAvailable: true,
            initialized: false,
            screen: Utils.getScreenInfo(),
            screenTimeout: null,
            reloadButtonTimeout: null
        }
    }

    componentDidUpdate(prevProps: Readonly<IProps>) {
        const {loaded} = this.props
        if (loaded !== prevProps.loaded){
            if (loaded && !this.state.initialized) {
                this.props.loadNotifications()
                PushNotificationsService.askPermission().then()
                this.setState({
                    initialized: true
                })
            }
        }
    }

    componentDidMount() {
        const {loaded, loading, load, onIsMobileChange} = this.props
        if (!loaded && !loading) {
            load()
        }
        onIsMobileChange(this.state.screen.isMobile)


        // const token = localStorage.getItem(AUTH_TOKEN)
        // let domain = ''
        // if (['development', 'dev'].includes(process.env.REACT_APP_ENV as string)){
        //     domain = 'ws://' + (new URL(process.env.REACT_APP_BASE_URL || '')).hostname
        // } else {
        //     domain = 'wss://' + (new URL(process.env.REACT_APP_BASE_URL || '')).hostname
        // }
        // console.log(domain)
        // const socket = new WebSocket(domain  + ':8080' + (token ? ['?token=' + token] : undefined) );
        //
        // socket.addEventListener('open', function (event) {
        //     // socket.send(JSON.stringify({ type: 'auth', token: localStorage.getItem(AUTH_TOKEN) }));
        //     console.log('Connected to WebSocket server');
        // });
        //
        // socket.addEventListener('message', function (event) {
        //     switch (event.data){
        //         case 'update_notification': reloadNotifications(); break;
        //         case 'test': console.log(event.data); break;
        //         default: console.log(event.data)
        //     };
        //
        //     // Update the UI with the notification
        // });
        //
        // socket.addEventListener('close',  (event) => {
        //     setInterval(() => reloadNotifications(), 30000)
        //     console.log('Disconnected from WebSocket server');
        // });

        Utils.registerScreenUpdate(
            (screenTimeout: NodeJS.Timeout) => this.setState({screenTimeout}),
            (screen: IScreen) => this.setState({screen}, () => onIsMobileChange(screen.isMobile)),
        )
    }

    //
    // componentDidUpdate(prevProps: Readonly<IProps>, prevState: Readonly<IState>, snapshot?: any) {
    //     // alert('A:'+  prevProps.loading)
    //     this.setState({reloadButtonTimeout: setTimeout(() => {
    //         alert('X')
    //         // this.setState({reloadAvailable: true, reloadButtonTimeout: null})
    //     }, 3000)});
    //     if(prevProps.loading && !prevState.reloadButtonTimeout) {
    //     }
    // }

    reload() {
        localStorage.clear()
        window.location.reload()
    }

    render() {
        const {loaded, match, history, settings, margin, fontSize, tableSize, headerHeight} = this.props
        const {reloadAvailable, screen} = this.state
        const {isMobile} = screen
        // const isNavSide = true
        // const isNavTop = false
        // const screens = utils.getBreakPoint(useBreakpoint());
        // const isMobile = !screens.includes('lg')
        // const isMobile = screen.isMobile
        let layoutGutter = this.props.navCollapsed ? SIDE_NAV_COLLAPSED_WIDTH : SIDE_NAV_WIDTH

        if (isMobile) {
            layoutGutter = 0;
        }
        // const isNavSide = navType === NAV_TYPE_SIDE
        // const isNavTop = navType === NAV_TYPE_TOP

        return (
            <div style={{"height": "100vh"}}>
                <Spin wrapperClassName={"h-100"} spinning={this.props.loading} style={{"height": "100vh"}} tip={(
                    <>
                        <div>
                            Načítám osobní nastavení ...
                        </div>
                        {reloadAvailable && (
                            <div className={"mt-2"}>
                                <Button onClick={() => this.reload()} type={"ghost"} size={"small"}
                                        style={{fontSize: 12}}><ReloadOutlined/> Načíst znovu</Button>
                            </div>
                        )}
                    </>
                ) as any}>
                    {loaded && (
                        <Layout>
                            <HeaderNav isMobile={isMobile} history={history} match={match} settings={settings}/>
                            <Layout
                                className={"app-container app-container-margin-" + margin + " app-container-font-size-" + fontSize + " app-container-table-" + tableSize}>
                                {!isMobile ?
                                    <SideNav settings={settings} match={match}
                                             history={history} headerHeight={headerHeight}/> : null}
                                <Layout id={'app-layout'} className="app-layout justify-content-between" style={{marginLeft: layoutGutter}}>
                                    <div className={'app-content flex-grow-1'} style={{
                                        marginTop: headerHeight + 'px',
                                    }}>
                                        <Content className={'h-100'}>
                                            <AppRouter match={match} history={history}/>
                                        </Content>
                                    </div>
                                    <Footer settings={settings}/>
                                </Layout>
                            </Layout>
                            {isMobile && (<MobileNav history={history} match={match} projectSettings={settings}/>)}
                        </Layout>
                    )}
                </Spin>
            </div>
        )
    }
}

const mapStateToProps = ({theme, setup}: IAppState) => {
    const {loaded, loading, modules, settings} = setup
    const {navCollapsed, navType, locale, margin, fontSize, tableSize, headerHeight} = theme;
    return {navCollapsed, navType, locale, loaded, loading, modules, margin, fontSize, tableSize, headerHeight, settings}
};

const mapDispatchToProps = {
    load: () => load(),
    loadNotifications: actions.notifications.load,
    reloadNotifications: actions.notifications.reload,
    onIsMobileChange: actions.theme.onIsMobileChange
}

export default connect(mapStateToProps, mapDispatchToProps)(React.memo(AppLayout));
